module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-row', {
    staticClass: "headTop"
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_vm._v("\n        类型名："), _c('el-input', {
    staticClass: "w150 mr20",
    attrs: {
      "placeholder": "请输入类型名",
      "clearable": ""
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.queryList()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success",
      "icon": "el-icon-circle-plus-outline"
    },
    on: {
      "click": function($event) {
        return _vm.showDialog()
      }
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.addType == 1 ? '增加票类型' : '修改票类型',
      "visible": _vm.dialogVisible,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparams",
    attrs: {
      "model": _vm.formparams,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "票类型名称",
      "prop": "type"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入票类型名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.formparams.type),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "type", $$v)
      },
      expression: "formparams.type"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('formparams')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formparams')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "height": "73vh",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ticketType",
      "label": "票类型名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pageination"
  }, [_c('el-col', [_c('el-pagination', {
    staticStyle: {
      "textAlign": "center",
      "marginTop": "10px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 40, 80, 100],
      "page-size": 20,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": this.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-675cdd9a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/buyTicket/ticketType.vue
// module id = 611
// module chunks = 70